// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Block = require("bs-platform/lib/js/block.js");
var Curry = require("bs-platform/lib/js/curry.js");

function map(res, fn) {
  if (res.tag) {
    return /* Error */Block.__(1, [res[0]]);
  } else {
    return /* Ok */Block.__(0, [Curry._1(fn, res[0])]);
  }
}

function flatMap(res, fn) {
  var match = map(res, fn);
  if (match.tag) {
    return /* Error */Block.__(1, [match[0]]);
  } else {
    var match$1 = match[0];
    if (match$1.tag) {
      return /* Error */Block.__(1, [match$1[0]]);
    } else {
      return /* Ok */Block.__(0, [match$1[0]]);
    }
  }
}

function liftM2(fn, a, b) {
  if (a.tag) {
    return /* Error */Block.__(1, [a[0]]);
  } else if (b.tag) {
    return /* Error */Block.__(1, [b[0]]);
  } else {
    return Curry._2(fn, a[0], b[0]);
  }
}

function liftM3(fn, a, b, c) {
  if (a.tag) {
    return /* Error */Block.__(1, [a[0]]);
  } else if (b.tag) {
    return /* Error */Block.__(1, [b[0]]);
  } else if (c.tag) {
    return /* Error */Block.__(1, [c[0]]);
  } else {
    return Curry._3(fn, a[0], b[0], c[0]);
  }
}

function lift2(fn, a, b) {
  return liftM2((function (goodA, goodB) {
                return /* Ok */Block.__(0, [Curry._2(fn, goodA, goodB)]);
              }), a, b);
}

function lift3(fn, a, b, c) {
  return liftM3((function (goodA, goodB, goodC) {
                return /* Ok */Block.__(0, [Curry._3(fn, goodA, goodB, goodC)]);
              }), a, b, c);
}

exports.map = map;
exports.flatMap = flatMap;
exports.lift2 = lift2;
exports.lift3 = lift3;
exports.liftM2 = liftM2;
exports.liftM3 = liftM3;
/* No side effect */



//////////////////
// WEBPACK FOOTER
// ../belt-holes/src/BeltHoles_Result.bs.js
// module id = 402
// module chunks = 0